module.exports = __webpack_public_path__ + "assets/img/xinzengyonghu.61202629.png";